// Local photo overrides for demo personas.
// LinkedIn signed URLs expire, so we serve photos from /public/demo-data/ instead.
const DEMO_PHOTOS = {
  'tom@vouch-demo.com': '/demo-data/tom.jpeg',
  'tracey@vouch-demo.com': '/demo-data/tracey.jpeg',
  'kevin@vouch-demo.com': '/demo-data/kevin.jpeg',
};

// Email-to-ID mapping, populated at runtime when profiles are fetched
const idToPhoto = {};

/**
 * Register a demo user's ID so we can override their photo_url in join queries
 * (which only return id, not email).
 */
export function registerDemoUser(id, email) {
  const photo = DEMO_PHOTOS[email];
  if (photo) idToPhoto[id] = photo;
}

/**
 * Override photo_url on a profile object (by email).
 */
export function applyDemoPhoto(profile) {
  if (!profile) return profile;
  const photo = DEMO_PHOTOS[profile.email];
  if (photo) profile.photo_url = photo;
  return profile;
}

/**
 * Override photo_url on nested profile objects from Supabase joins (by id).
 * Mutates in place for convenience.
 */
export function patchJoinPhotos(rows) {
  if (!rows) return rows;
  for (const row of rows) {
    if (row.candidate && idToPhoto[row.candidate.id]) {
      row.candidate.photo_url = idToPhoto[row.candidate.id];
    }
    if (row.voucher && idToPhoto[row.voucher.id]) {
      row.voucher.photo_url = idToPhoto[row.voucher.id];
    }
    if (row.jobs?.hiring_manager && idToPhoto[row.jobs.hiring_manager.id]) {
      row.jobs.hiring_manager.photo_url = idToPhoto[row.jobs.hiring_manager.id];
    }
  }
  return rows;
}

export { DEMO_PHOTOS };
